export default "__VITE_ASSET__Dzivbibk__"